
//METTRE A true AVANT DEPLOIEMENT et A false POUR DEPLOIEMENT
// [TEST LOCAL] mis a false pour cibler le backend local via le proxy Vite (/loc -> localhost:61737).
// A REMETTRE A true avant tout commit/deploiement.
let configDeploiment = true;

function getConfig() {
    let config;
    //CONFIG pour le dÃ©ploiement
    if (configDeploiment) {
        config = {
            // //urlBackEnd: "https://82.127.136.182:22122/ASPSite",
            // urlBackEnd: "http://185.74.10.201:44329/",
            // urlFrontEnd: "",
            // urlSubBackEnd: localStorage.getItem("urlSubBackEnd"),
            // urlBackEndParent: "http://185.74.10.201:44329/"

            // Reverse proxy Nginx : le front (https://login.fisi.fr) appelle le
            // backend via /backend/, Nginx relaie vers Kestrel http://127.0.0.1:5000/
            // en interne (evite mixed content + CORS). Voir deploy/nginx-fisiweb.conf
            // Base ORIGINE-RELATIVE : suit l'origine reelle de la page. Identique a
            // https://login.fisi.fr/backend/ en temps normal, mais bascule automatiquement
            // sur https://192.168.2.201/backend/ si la WebView Android est tombee sur l'IP
            // de secours (DNS WireGuard non resolu). Front + backend = meme origine (Nginx).
            // BackEndFInal (FSE/Assertion/Patient) = Kestrel 127.0.0.1:5001, expose par Nginx en
            // /final/ (cf deploy/nginx fisiweb). /backend/ pointe sur BackEndParent (5000 = login/CPS)
            // -> urlBackEnd DOIT viser /final/, sinon tous les appels FSE/Assertion tombent en 404.
            urlBackEnd: window.location.origin + "/final/",
            urlFrontEnd: "",
            urlSubBackEnd: localStorage.getItem("urlSubBackEnd"),
            // BackEndParent (login, CPS, Client) reste sur /backend/ (5000).
            urlBackEndParent: window.location.origin + "/backend/"
        }
    }
    else {
        // DEV. Sur le PC (npm run dev, navigateur localhost) : backends locaux en direct (INCHANGE).
        // Depuis un autre appareil (mobile-dev via l'IP LAN du PC) : localhost = le device, donc on
        // passe par le PROXY Vite (meme origine -> login.fisi.fr, cf vite.config.js server.proxy).
        // URL ABSOLUE = origine (pas relative) pour eviter le double-prefixe (config.urlBackEnd sert
        // aussi de axios baseURL).
        const surPc = (typeof window !== "undefined")
            && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
        config = surPc ? {
            // [TEST LOCAL] via proxy Vite same-origin (cf vite.config.js proxy '/loc') -> pas de CORS,
            // ne tape JAMAIS la prod. URL ABSOLUE (origin) : le front prefixe deja config.urlBackEnd
            // ET axios a baseURL=urlBackEnd -> une URL relative serait doublee (/loc/loc/...). Absolue
            // same-origin -> axios ne prefixe pas, et le navigateur passe par le proxy /loc.
            urlBackEnd: window.location.origin + "/loc/",
            urlFrontEnd: "",
            urlSubBackEnd: null,
            urlBackEndParent: window.location.origin + "/loc/"
        } : {
            urlBackEnd: window.location.origin + "/backend/",
            urlFrontEnd: "",
            urlSubBackEnd: localStorage.getItem("urlSubBackEnd"),
            urlBackEndParent: window.location.origin + "/backend/"
        };
    }
    return config;
}

const config = getConfig();

export default config;
